import React, { useEffect, useState } from 'react';
import { AutoComplete, Button, Modal, Space, Typography, notification } from 'antd';
import AxiosUtils from 'utils/axios-utils';
import { API } from 'service/api-route';
import { VoteEntry, apiErrorText, displayName, formatScore } from './types';

const REASONS = [
  'Không đủ điều kiện tham gia',
  'Thêm nhầm người',
  'Vi phạm thể lệ',
  'Bị loại theo vòng',
];

interface Props {
  voteId: number | string;
  /** Rỗng = đóng */
  entries: VoteEntry[];
  onClose: () => void;
  onDone: () => void;
}

/** Loại một hoặc nhiều người khỏi danh sách bình chọn, kèm lý do. */
const RemoveEntriesModal = ({ voteId, entries, onClose, onDone }: Props) => {
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const open = entries.length > 0;

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  const submit = async () => {
    setSaving(true);
    try {
      await AxiosUtils.post(API.voteAdminRemove(voteId), {
        entryIds: entries.map((e) => e.id),
        reason: reason.trim(),
      });
      notification.success({ message: `Đã loại ${entries.length} người khỏi danh sách` });
      onDone();
    } catch (e) {
      notification.error({ message: 'Không thành công', description: apiErrorText(e) });
    } finally {
      setSaving(false);
    }
  };

  const names = entries.slice(0, 5).map(displayName).join(', ');

  return (
    <Modal
      open={open}
      title={
        entries.length > 1 ? `Loại ${entries.length} người khỏi danh sách?` : 'Loại khỏi danh sách?'
      }
      onCancel={onClose}
      maskClosable={!reason}
      footer={[
        <Button key="cancel" onClick={onClose}>
          Không
        </Button>,
        <Button
          key="ok"
          type="primary"
          danger
          loading={saving}
          disabled={reason.trim().length < 3}
          onClick={submit}
        >
          Loại khỏi danh sách
        </Button>,
      ]}
    >
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <Typography.Text>
          <b>
            {names}
            {entries.length > 5 ? ` và ${entries.length - 5} người khác` : ''}
          </b>{' '}
          sẽ không còn trên bảng xếp hạng của app
          {entries.length === 1 ? ` (đang có ${formatScore(entries[0].score)} điểm)` : ''}. Điểm
          hiện tại vẫn được ghi trong Lịch sử điều chỉnh.
        </Typography.Text>
        <div>
          <Typography.Text>Lý do (bắt buộc)</Typography.Text>
          <AutoComplete
            style={{ width: '100%', marginTop: 6 }}
            value={reason}
            onChange={setReason}
            options={REASONS.map((value) => ({ value }))}
            placeholder="Chọn hoặc gõ lý do"
            maxLength={255}
          />
        </div>
      </Space>
    </Modal>
  );
};

export default RemoveEntriesModal;
